import axios from "axios";
import { applyAmplitudeRequestHeaders } from "./applyAmplitudeRequestHeaders";
import { getClientApiUrl } from "@/utils";

const apiHost = getClientApiUrl();

const apiClient = axios.create({
  baseURL: apiHost,
});

apiClient.interceptors.request.use(applyAmplitudeRequestHeaders);

export default apiClient;
